
export const isLoggedIn 	= state => !!state.token
export const token 			= state => state.token
export const access_token	= (state, getters) => getters.token ? getters.token.split(';')[0] : false
export const refresh_token	= (state, getters) => getters.token ? getters.token.split(';')[1] : false
export const expires_in		= (state, getters) => getters.token ? getters.token.split(';')[2] : false
export const user 			= state => state.user
export const language 		= (state, getters) => getters.user ? getters.user.language : 'en'